// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgrammeCreateView_container__2SPeF","addSessionButton":"ProgrammeCreateView_addSessionButton__3uDIn","closeButton":"ProgrammeCreateView_closeButton__39zXi"};